import flagus from "../../assets/images/flags/us.svg";
import flagspain from "../../assets/images/flags/spain.svg";
import flagfrench from "../../assets/images/flags/french.svg";
import flagarabic from "../../assets/images/flags/ar.svg";

const languages = {
  fr: {
    label: "Français",
    flag: flagfrench,
    initial:"FR"
  },
  en: {
    label: "English",
    flag: flagus,
    initial:"EN"
  },
  // ar: {
  //   label: "Arabic",
  //   flag: flagarabic,
  //   initial:"AR"
  // },
  // sp: {
  //   label: "Española",
  //   flag: flagspain,
  //   initial:"ES"
  // },
}

export default languages
